var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-notification"},[_c('div',{staticClass:"widget-notification__wrapper"},[_c('v-alert',{attrs:{"type":_vm.notificationType,"color":_vm.themeColors.secondary}},[_vm._v(_vm._s(_vm.message)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }